class ErrorMessage extends Error {
  constructor(message) {
    super(message); // (1)
    this.name = "ErrorMessage"; // (2)
  }
}

export default ErrorMessage;
